import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './examDataActionType';
import * as actions from './examDataActions';
import * as services from './examDataService';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';

//------------------ Exam Data
function* fetchExamDataSaga(action) {
    try {
        const response = yield call(services.getAllExamData, action.payload);

        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.fetchExamDataSuccess(response?.values));

    } catch (error) {
        let errorMessage = 'Failed to fetch exam data.';
        console.error('Exam Data API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchExamDataFailure(errorMessage));
    }
}

//------------------ Exam Data Dropdown Options
function* fetchExamDropdownOptionsSaga(action) {
    try {
        const response = yield call(services.getExamDropdownOptions, action.payload);

        yield put(actions.fetchExamDropdownOptionsSuccess(response?.values));
    } catch (error) {
        console.error("Exam Dropdown Options API Error:", error);
        yield put(actions.fetchExamDropdownOptionsFailure('Failed to fetch exam dropdown options.'));
    }
}

//------------------ Recalculate Data
function* fetchRecalculateDataSaga() {
    try {
        const response = yield call(services.getRecalculateData);

        yield put(actions.fetchRecalculateDataSuccess(response?.values));
    } catch (error) {
        console.error("Recalculate Data API Error:", error);
        yield put(actions.fetchRecalculateDataFailure('Failed to fetch recalculate data.'));
    }
}

//------------------ Exam Data Record Date
function* updateExamDataRecordDateSaga(action) {
    try {
        const response = yield call(services.updateExamDataRecordDate, action.payload);
        yield put(actions.updateExamDataRecordDateSuccess(response?.values));
    } catch (error) {
        console.error("Update Exam Data Record Date API Error:", error);
        yield put(actions.updateExamDataRecordDateFailure('Failed to update exam data record date.'));
    }
}

function* refreshRawExamDataSaga(action) {
    try {
        const response = yield call(services.refreshRawExamData, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }

        yield put(actions.refreshRawExamDataSuccess(response?.values));
    } catch (error) {
        let errorMessage = 'Failed to refresh raw exam data.';
        console.error('Refresh Raw Exam Data API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.refreshRawExamDataFailure(errorMessage));
    }
}

function* saveBatchRecordExamDataSaga(action) {
    try {
        const response = yield call(
            services.getBatchRecordExamData,
            action.payload.ID
        );

        yield put(
            actions.saveBatchRecordExamDataSuccess(response?.values)
        );
    } catch (error) {
        console.error("Save Batch Record Exam Data API Error:", error);
        yield put(
            actions.saveBatchRecordExamDataFailure(
                'Failed to save batch record exam data.'
            )
        );
    }
}

//Get batch by record date
function* fetchExamDataBatchSaga(action) {
    try {
        const response = yield call(services.getExamDataBatchByRecordDate, action.payload.recordDate);
        yield put(actions.fetchExamDataBatchSuccess(response?.values));
    } catch (error) {
        console.error("Fetch Exam Data Batch API Error:", error);
        yield put(actions.fetchExamDataBatchFailure('Failed to fetch exam data batch.'));
    }
}

//Save batch record
function* saveBatchRecordSaga(action) {
    try {
        const response = yield call(services.saveBatchRecord, action.payload);
        yield put(actions.saveBatchRecordSuccess(response?.values));

        if (response && response.success) {
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Status updated successfully.'
            });
        }else {
            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to update status.'
            });
        }
    } catch (error) {
        yield put(actions.saveBatchRecordFailure('Failed to save batch record.'));
        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to save batch record'
        });
    }
}

// Check Recalculation
function* checkRecalculationSaga() {
    try {
        const response = yield call(services.checkRecalculation);
        yield put(actions.checkRecalculationSuccess(response?.values));

        if (response && response.success) {
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'updated successfully.'
            });
        }else {
            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to update.'
            });
        }
    } catch (error) {
        console.error("Check Recalculation API Error:", error);
        yield put(actions.checkRecalculationFailure('Failed to check recalculation.'));
        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to check recalculation'
        });
    }
}

// Re Calculate Exam Data Details
function* reCalculateExamDataDetailsSaga(action) {
    try {
        const response = yield call(services.reCalculateExamDataDetails, action.payload);
        yield put(actions.reCalculateExamDataDetailsSuccess(response?.values));
    } catch (error) {
        console.error("Re Calculate Exam Data Details API Error:", error);
        yield put(actions.reCalculateExamDataDetailsFailure('Failed to re calculate exam data details.'));
    }
}



export default function* watchMiscellaneousSaga() {
    yield takeEvery(types.FETCH_EXAM_DATA_REQUEST, fetchExamDataSaga);
    yield takeEvery(types.FETCH_EXAM_DROPDOWN_OPTIONS_REQUEST, fetchExamDropdownOptionsSaga);
    yield takeEvery(types.FETCH_RECALCULATE_DATA_REQUEST, fetchRecalculateDataSaga);
    yield takeEvery(types.UPDATE_EXAM_DATA_RECORD_DATE_REQUEST, updateExamDataRecordDateSaga);
    yield takeEvery(types.REFRESH_RAW_EXAM_DATA_REQUEST, refreshRawExamDataSaga);
    yield takeEvery(types.SAVE_BATCH_RECORD_EXAM_DATA_REQUEST, saveBatchRecordExamDataSaga);
    yield takeEvery(types.FETCH_EXAM_DATA_BATCH_REQUEST, fetchExamDataBatchSaga);
    yield takeEvery(types.SAVE_BATCH_RECORD_REQUEST, saveBatchRecordSaga);
    yield takeEvery(types.CHECK_RECALCULATION_REQUEST, checkRecalculationSaga);
    yield takeEvery(types.RE_CALCULATE_EXAM_DATA_DETAILS_REQUEST, reCalculateExamDataDetailsSaga);
}